var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "modal fade bd-example-modal-lg",
      attrs: {
        id: "errorModal",
        "aria-hidden": "true",
        "aria-labelledby": "exampleModalLabel",
        "data-backdrop": "static",
        role: "dialog",
        tabindex: "-1",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg",
          attrs: {
            role: "document",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
            },
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                },
                [
                  _vm.errorImport
                    ? _c(
                        "div",
                        {
                          staticClass: "error-box",
                        },
                        _vm._l(_vm.errorImport, function (el, index) {
                          return _c(
                            "p",
                            {
                              key: index,
                            },
                            [
                              _c("icon", {
                                staticClass: "icon-toast text-center",
                                staticStyle: {
                                  color: "#F21100",
                                },
                                attrs: {
                                  name: "exclamation-triangle",
                                },
                              }),
                              _vm._v(" " + _vm._s(el.error) + " "),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
              _vm._m(1),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-header",
      },
      [
        _c(
          "h5",
          {
            staticClass: "modal-title",
            attrs: {
              id: "exampleModalLabel",
            },
          },
          [_vm._v(" Error List ")]
        ),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              "aria-label": "Close",
              "data-dismiss": "modal",
              type: "button",
            },
          },
          [
            _c(
              "span",
              {
                attrs: {
                  "aria-hidden": "true",
                },
              },
              [_vm._v("×")]
            ),
          ]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-footer",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: {
              "data-dismiss": "modal",
              type: "button",
            },
          },
          [_vm._v(" OK ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }